import { useAuth0 } from '@auth0/auth0-react';
import { RouterProvider } from '@tanstack/react-router';
import { useEffect } from 'react';

import { TokenManager } from './auth/TokenManager';
import { Loading } from './Loading';
import { router } from './router';

export const App = () => {
    const auth = useAuth0();

    useEffect(() => {
        TokenManager.getInstance().initialize(auth.getAccessTokenSilently);
    }, [auth.getAccessTokenSilently]);

    if (auth.isLoading) {
        return <Loading />;
    }

    return <RouterProvider router={router} context={{ auth }} />;
};
